<section class="atw-page faqs-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">

    <!-- Hero -->
    <div class="faqs-hero">
      <div class="faqs-hero-content">
        <div class="hero-badge">
          <span>{{ 'atw.faqs.hero.badgeNumber' | transloco }}</span>
          {{ 'atw.faqs.hero.badgeTitle' | transloco }}
        </div>

        <h1>
          {{ 'atw.faqs.hero.titleLine1' | transloco }}
          <strong>{{ 'atw.faqs.hero.titleStrong' | transloco }}</strong>
        </h1>

        <p>
          {{ 'atw.faqs.hero.description' | transloco }}
        </p>

        <div class="hero-actions">
          <a class="primary-action" href="#faqs-list">

            {{ 'atw.faqs.hero.primaryBtn' | transloco }}
          </a>

          <a class="secondary-action" href="#faqs-contact">
            {{ 'atw.faqs.hero.secondaryBtn' | transloco }}
          </a>
        </div>
      </div>

      <div class="faqs-hero-visual">
        <div class="faqs-visual-card">
          <div class="faqs-visual-icon">
            <img class="img-l" src="assets/as/53.webp" alt="faq" />
          </div>

          <strong>{{ 'atw.faqs.hero.visualTitle' | transloco }}</strong>
          <p>{{ 'atw.faqs.hero.visualText' | transloco }}</p>
        </div>

        <div class="floating-card faqs-floating-card">
          <div>
            <strong>{{ 'atw.faqs.hero.floatTitle' | transloco }}</strong>
            <small>{{ 'atw.faqs.hero.floatText' | transloco }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Intro Stats -->
    <section class="apply-section">
      <div class="faqs-mini-grid">
        <div class="apply-card faq-mini-card">
          <img class="img-m" src="assets/as/8.png" alt="fast" />

          <div>
            <strong>{{ 'atw.faqs.stats.fast.title' | transloco }}</strong>
            <p>{{ 'atw.faqs.stats.fast.text' | transloco }}</p>
          </div>
        </div>

        <div class="apply-card faq-mini-card">
          <img class="img-m" src="assets/as/12.webp" alt="cv" />

          <div>
            <strong>{{ 'atw.faqs.stats.cv.title' | transloco }}</strong>
            <p>{{ 'atw.faqs.stats.cv.text' | transloco }}</p>
          </div>
        </div>

        <div class="apply-card faq-mini-card">
          <img class="img-m" src="assets/as/1.webp" alt="abroad" />

          <div>
            <strong>{{ 'atw.faqs.stats.abroad.title' | transloco }}</strong>
            <p>{{ 'atw.faqs.stats.abroad.text' | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ List -->
    <section class="apply-section" id="faqs-list">
      <div class="section-title">
        <span>
          <b>{{ 'atw.faqs.list.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.faqs.list.title' | transloco }}</h2>
          <p>{{ 'atw.faqs.list.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card faqs-tools">
        <label class="faqs-search">
          <span>{{ 'atw.faqs.filters.searchLabel' | transloco }}</span>

          <input
            type="text"
            [value]="searchTerm"
            (input)="onSearch($event)"
            [placeholder]="'atw.faqs.filters.searchPlaceholder' | transloco"
          />
        </label>

        <div class="faqs-categories">
          <button
            type="button"
            *ngFor="let category of categories; trackBy: trackByCategory"
            class="faq-filter-btn"
            [class.active]="activeCategory === category.id"
            (click)="setCategory(category.id)"
          >
            {{ category.labelKey | transloco }}
          </button>
        </div>
      </div>

      <div class="faqs-layout" *ngIf="filteredFaqs.length; else emptyFaqs">
        <div class="faqs-list">
          <article
            class="faq-item"
            *ngFor="let faq of filteredFaqs; trackBy: trackByFaq"
            [class.open]="isOpen(faq.id)"
          >
            <button
              type="button"
              class="faq-question"
              [attr.aria-expanded]="isOpen(faq.id)"
              (click)="toggleFaq(faq.id)"
            >
              <span class="faq-icon">
                <img
                  class="img-m"
                  [src]="faq.iconImg"
                  [alt]="faq.questionKey | transloco"
                />
              </span>

              <span class="faq-title">
                {{ faq.questionKey | transloco }}
              </span>

              <span class="faq-state">
                {{ isOpen(faq.id) ? '−' : '+' }}
              </span>
            </button>

            <div class="faq-answer" *ngIf="isOpen(faq.id)">
              <p>{{ faq.answerKey | transloco }}</p>
            </div>
          </article>
        </div>

        <aside class="apply-card faqs-side-card">
          <span>{{ 'atw.faqs.side.badge' | transloco }}</span>
          <h3>{{ 'atw.faqs.side.title' | transloco }}</h3>
          <p>{{ 'atw.faqs.side.text' | transloco }}</p>

        </aside>
      </div>

      <ng-template #emptyFaqs>
        <div class="apply-card faqs-empty">
          <div>
            <img class="img-m" src="assets/as/2.webp" alt="search" />
          </div>

          <h3>{{ 'atw.faqs.empty.title' | transloco }}</h3>
          <p>{{ 'atw.faqs.empty.text' | transloco }}</p>

          <button type="button" class="primary-action" (click)="resetFilters()">
            <span>↺</span>
            {{ 'atw.faqs.empty.btn' | transloco }}
          </button>
        </div>
      </ng-template>
    </section>

    <!-- CTA -->
    <section class="apply-section" id="faqs-contact">
      <div class="apply-card faqs-cta">
        <div>
          <span>{{ 'atw.faqs.cta.badge' | transloco }}</span>
          <h2>{{ 'atw.faqs.cta.title' | transloco }}</h2>
          <p>{{ 'atw.faqs.cta.text' | transloco }}</p>
        </div>

        <a class="primary-action" routerLink="/jobs">
          {{ 'atw.faqs.cta.btn' | transloco }}
        </a>
      </div>
    </section>

  </div>
</section>